import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  return <section className="bg-light py-20 px-4" data-id="element-107">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center" data-id="element-108">
        <h2 className="md:text-4xl font-bold text-textDark mb-10 text-[24px]" data-id="element-109">
          Estás sobreviviendo... pero lo llamas crecimiento.
        </h2>

        <div className="flex flex-col items-start text-left gap-4 mb-12 w-full max-w-2xl mx-auto" data-id="element-110">
          <div className="flex items-start gap-3" data-id="element-111">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-112" />
            <span className="text-lg text-textDark font-medium" data-id="element-113">
              Tu agenda está llena, pero tu negocio no crece en proporción.
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-114">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-115" />
            <span className="text-lg text-textDark font-medium" data-id="element-116">
              Tu negocio depende demasiado de ti.
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-117">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-118" />
            <span className="text-lg text-textDark font-medium" data-id="element-119">
              Tomas decisiones cansada.
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-120">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-121" />
            <span className="text-lg text-textDark font-medium" data-id="element-122">
              Sientes que haces mucho, pero avanzas poco.
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-123">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-124" />
            <span className="text-lg text-textDark font-medium" data-id="element-125">
              Sabes que podrías operar mejor.
            </span>
          </div>
        </div>

        <p className="text-xl text-textDark font-medium mb-10" data-id="element-126">
          No es falta de capacidad.
          <br data-id="element-127" />
          Te sobra carga mal diseñada.
        </p>

        <CTAButton className="w-full md:w-auto" data-id="element-128">
          QUIERO VER QUÉ ELIMINAR
        </CTAButton>
      </div>
    </section>;
}